// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__kBQZt","widthDorpdown":"footer_widthDorpdown__CdLSR"};